import { CALL_API } from 'middleware/api';

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const BEGIN_LOGOUT = 'BEGIN_LOGOUT';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const RESTORE_AUTH = 'RESTORE_AUTH';
export const VERIFY_MFA = 'VERIFY_MFA';
export const VERIFY_MFA_SETUP = 'VERIFY_MFA_SETUP';
export const CLEAR_MFA_CHALLENGE = 'CLEAR_MFA_CHALLENGE';

export const AUTHENTICATED = 'AUTHENTICATED';
export const MFA_REQUIRED = 'MFA_REQUIRED';
export const MFA_SETUP_REQUIRED = 'MFA_SETUP_REQUIRED';

export const login = credentials => dispatch => (
    dispatch({
        email: credentials.email,
        [CALL_API]: {
            type: LOGIN,
            endpoint: '/api/v1/auth/login',
            method: 'post',
            body: credentials,
            submitFormRequest: true,
        },
    })
);

export const verifyMfa = ({ email, session, code }) => dispatch => (
    dispatch({
        [CALL_API]: {
            type: VERIFY_MFA,
            endpoint: '/api/v1/auth/mfa/verify',
            method: 'post',
            body: { email, session, code },
            submitFormRequest: true,
            publicRequest: true,
        },
    })
);

export const verifyMfaSetup = ({ email, session, code }) => dispatch => (
    dispatch({
        [CALL_API]: {
            type: VERIFY_MFA_SETUP,
            endpoint: '/api/v1/auth/mfa/setup/verify',
            method: 'post',
            body: { email, session, code },
            submitFormRequest: true,
            publicRequest: true,
        },
    })
);

export const clearMfaChallenge = () => dispatch => (
    dispatch({
        type: CLEAR_MFA_CHALLENGE,
    })
);
export const refreshToken = token => dispatch => (
    dispatch({
        [CALL_API]: {
            type: REFRESH_TOKEN,
            endpoint: '/api/v1/auth/token/refresh',
            method: 'post',
            body: { refreshToken: token },
        },
    })
);

export const restoreAuth = appToken => ({
    type: RESTORE_AUTH,
    appToken,
});

export const logout = () => dispatch => (
    dispatch({
        type: LOGOUT,
    })
);

export const beginLogout = () => dispatch => (
    dispatch({
        type: BEGIN_LOGOUT,
    })
);
